import * as React from "react";
import { glyphSvg, type GlyphKey } from "./markers";

interface Props {
  glyph: GlyphKey;
  size?: number;
  // 픽토그램 색.
  fg?: string;
  // "파낸" 부분(방패 안 십자 등)에 칠할 색 = 픽토그램이 놓이는 배경색.
  bg?: string;
  style?: React.CSSProperties;
}

// 범례·상세 패널이 지도 마커와 "똑같은" 픽토그램을 쓰게 하는 얇은 래퍼.
// 마커는 SDK에 HTML 문자열로 넘겨야 해서 markers.ts가 문자열을 만들고,
// React 쪽은 그 문자열을 그대로 주입한다(단일 출처 유지).
export function MarkerGlyph({ glyph, size = 14, fg = "#fff", bg = "transparent", style }: Props) {
  return (
    <span
      aria-hidden="true"
      style={{ display: "inline-flex", width: size, height: size, flex: "none", ...style }}
      dangerouslySetInnerHTML={{ __html: glyphSvg(glyph, { size, fg, bg }) }}
    />
  );
}
